<template>
  <Exception />
</template>

<script>
import Exception from "@/components/Exception";

export default {
  components: { Exception },
};
</script>
